import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

import { moodColors } from 'styles';

interface IProps {
  options?: any;
  data: any[];
  previousData?: any[];
  yName?: string;
}

const defaultOptions = {
  dataLabels: {
    enabled: false,
  },
  animations: {
    enabled: true,
    easing: 'easeinout',
    speed: 800,
    animateGradually: {
      enabled: true,
      delay: 150,
    },
    dynamicAnimation: {
      enabled: true,
      speed: 350,
    },
  },
  colors: ['#fff'],
};

const BarChart: React.FC<IProps> = ({ options, data }) => {
  const formattedData = useMemo(() => {
    if (!data) return {};
    const serie1: any = [];
    const serie2: any = [];
    const categories: any = [];
    data.forEach(d => {
      categories.push(d.channel);
      serie1.push(d.memberActivity);
      serie2.push(d.channelActivity);
    });
    return { serie1, serie2, categories };
  }, [data]);

  const mergedOptions = {
    ...defaultOptions,
    ...(options || {}),
    chart: {
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      ...(options || {}).xaxis,
      categories: formattedData.categories,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
        },
      },
      barHeight: '50%',
    },
    stroke: {
      show: true,
      colors: '#fff',
      width: 2,
    },
    fill: {
      type: ['solid', 'pattern'],
      colors: [
        function ({ seriesIndex, dataPointIndex }: any) {
          const evaluatedSerie = seriesIndex === 0 ? 'memberMood' : 'channelMood';
          const evaluatedNumber = data[dataPointIndex][evaluatedSerie];
          if (evaluatedNumber < 0.333) {
            return moodColors.negative;
          } else if (evaluatedNumber >= 0.333 && evaluatedNumber < 0.666) {
            return moodColors.neutral;
          } else {
            return moodColors.positive;
          }
        },
      ],
      pattern: {
        style: 'slantedLines',
        strokeWidth: 3,
      },
    },
  };

  const series = [
    {
      data: formattedData.serie1,
      name: 'Member',
    },
    {
      data: formattedData.serie2,
      name: 'Channel Average',
    },
  ];

  return (
    <>
      <Chart options={mergedOptions} series={series} type="bar" />
    </>
  );
};

export default BarChart;
